export const SAVE = 'changesToYourJourney.SAVE';
export const VALUE_CHANGED = 'changesToYourJourney.VALUE_CHANGED';
export const LOAD = 'changesToYourJourney.VALUE_LOAD';
export const NEXT = 'changesToYourJourney.NEXT';
export const RESET = 'changesToYourJourney.RESET';
export const RESET_DAMAGED_LOST_EXPENSE = 'changesToYourJourney.RESET_DAMAGED_LOST_EXPENSE';
export const RESET_DELAYED_LUGGAGE_EXPENSE = 'changesToYourJourney.RESET_DELAYED_LUGGAGE_EXPENSE';
export const RESET_COMPENSATION = 'changesToYourJourney.RESET_COMPENSATION';
//-------------------------------------------------------
export const RESET_TRIP_CANCELLATION_STATE = 'changesToYourJourney.RESET_TRIP_CANCELLATION_STATE';
export const RESET_TRAVEL_INTERRUPTION_STATE = 'changesToYourJourney.RESET_TRAVEL_INTERRUPTION_STATE';

export const GET_FLIGHT_STATUS_REQUEST = 'changesToYourJourney.GET_FLIGHT_STATUS_REQUEST';
export const GET_FLIGHT_STATUS_SUCCESS = 'changesToYourJourney.GET_FLIGHT_STATUS_SUCCESS';
export const GET_FLIGHT_STATUS_ERROR = 'changesToYourJourney.GET_FLIGHT_STATUS_ERROR';

export const CURRENT_STEP_NAME = 'Trawick.ChangesToYourJourney';
export const RESET_FORM_FIELDS = 'changesToYourJourney.RESET_FORM_FIELDS';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '18',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.ChangesToYourJourney/constants.js